import {valueType} from "antd/es/statistic/utils";

const formatCost = (value: valueType | undefined) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export {formatCost};
